import * as z from "zod";

const draftReturnFlowPathsSchema = z.object({
  flow: z.object({ _id: z.string().nullish() }),
  pendingReturnItems: z.array(
    z.object({
      id: z.string(),
      returnableItemId: z.string(),
      flowPath: z.array(z.number()).readonly(),
    }),
  ),
});

/** The return page's view of a draft return: its flow and each pending item's path. */
export type DraftReturnFlowPaths = z.infer<typeof draftReturnFlowPathsSchema>;

export const getDraftReturn = {
  name: "getDraftReturn" as const,
  input: z.object({ draftReturnId: z.string() }),
  output: z.object({ draftReturn: draftReturnFlowPathsSchema.nullish() }),
};
